import { createSelector } from 'reselect';
import { actionTypes } from '../actions';

export const moduleName = 'signIn';

// Reducer (down)

const initialState = {
  processed: false,
  processing: false,
  error: '',
};

export default function reducer(state = initialState, action) {
  const { type, error } = action;

  switch (type) {
    case actionTypes.SIGN_IN_FETCH_USER_DATA_REQUEST:
    case actionTypes.SIGN_IN_LOGIN_REQUEST:
      return {
        ...state,
        processing: true,
        error: initialState.error,
      };

    case actionTypes.SIGN_IN_FETCH_USER_DATA_SUCCESS:
    case actionTypes.SIGN_IN_LOGIN_SUCCESS:
      return {
        ...state,
        processed: true,
        processing: false,
      };

    case actionTypes.SIGN_IN_FETCH_USER_DATA_FAILURE:
    case actionTypes.SIGN_IN_LOGIN_FAILURE:
      return {
        ...state,
        processed: true,
        processing: false,
        // TODO Add more informative error message
        error: error || 'Unknown error',
      };

    case actionTypes.SIGN_IN_SET_PROCESSED:
      return {
        ...state,
        processed: true,
      };

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

const stateSelector = (state) => state[moduleName];

export const selectSignInProcessed = createSelector(
  stateSelector,
  (signIn) => signIn.processed,
);

export const selectSignInProcessing = createSelector(
  stateSelector,
  (signIn) => signIn.processing,
);

export const selectSignInError = createSelector(
  stateSelector,
  (signIn) => signIn.error,
);

// Selectors (up



// WEBPACK FOOTER //
// ./reducers/sign-in.js